var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 10.6158L8.90166 17.0266C8.19839 17.7299 7.24456 18.125 6.24999 18.125C5.25542 18.125 4.30159 17.7299 3.59833 17.0266C2.89506 16.3234 2.49997 15.3695 2.49997 14.375C2.49997 13.3804 2.89506 12.4266 3.59833 11.7233L12.715 2.60663C12.9472 2.37452 13.2229 2.19042 13.5262 2.06485C13.8296 1.93927 14.1547 1.87468 14.4831 1.87476C14.8114 1.87483 15.1365 1.93958 15.4398 2.0653C15.7431 2.19102 16.0187 2.37525 16.2508 2.60747C16.4829 2.83969 16.667 3.11535 16.7926 3.41872C16.9182 3.72209 16.9828 4.04722 16.9827 4.37556C16.9826 4.70389 16.9179 5.02899 16.7922 5.3323C16.6664 5.63561 16.4822 5.91119 16.25 6.1433L7.12666 15.2666C6.88998 15.4935 6.57363 15.6175 6.24578 15.6134C5.91793 15.6092 5.60485 15.4764 5.37399 15.2436C5.14314 15.0108 5.013 14.6966 5.01163 14.3687C5.01026 14.0408 5.13776 13.7255 5.36666 13.4908L11.875 6.98247M7.13416 15.2583L7.12583 15.2666",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperClip);
export default __webpack_public_path__ + "static/media/PaperClip.cb3636e0bca52321c5091af987c78697.svg";
export { ForwardRef as ReactComponent };